import { render, staticRenderFns } from "./BasicShipmentTypeSettingsStep.vue?vue&type=template&id=bfceca92&scoped=true&"
import script from "./BasicShipmentTypeSettingsStep.vue?vue&type=script&lang=js&"
export * from "./BasicShipmentTypeSettingsStep.vue?vue&type=script&lang=js&"
import style0 from "./BasicShipmentTypeSettingsStep.vue?vue&type=style&index=0&id=bfceca92&prod&lang=scss&"
import style1 from "./BasicShipmentTypeSettingsStep.vue?vue&type=style&index=1&id=bfceca92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfceca92",
  null
  
)

export default component.exports